"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.autoCreateLinkedGolfTransfer = void 0;
const uuid_1 = require("uuid");
const dayjs = require("dayjs");
const helpers_1 = require("../../helpers");
const orders_1 = require("../orders");
const searchTransferRatesIncludingHistorical_1 = require("./searchTransferRatesIncludingHistorical");
const _ = require("lodash");
const autoCreateLinkedGolfTransfer = async (order_id, golf_order_line_id, variant_id, course_id, client, linked_line_data, supabase) => {
    const order = await (0, orders_1.getOrderById)(supabase, order_id);
    const golf_transfer_line = {
        id: (0, uuid_1.v4)(),
        order_id: order_id,
        order_variant_id: variant_id,
        type: "TRANSFER",
    };
    let transfer_line_config = _.cloneDeep(helpers_1.TRANSFER_LINE_INITIAL_STATE);
    transfer_line_config.where_when_who.date = dayjs(linked_line_data.start_date).format("YYYY-MM-DD");
    transfer_line_config.where_when_who.type = "RETURN";
    transfer_line_config.where_when_who.number_of_passengers =
        linked_line_data.number_of_passengers;
    transfer_line_config.where_when_who.region_id = linked_line_data.region_id;
    transfer_line_config.where_when_who.pickup_name = `${client?.first_name} ${client?.last_name}`;
    // OUTBOUND
    transfer_line_config.transfer_legs.outbound = {
        to_area: linked_line_data.outbound_to_area,
        to_name: linked_line_data.outbound_to_name,
        to_type: linked_line_data.outbound_to_type,
        from_area: linked_line_data.outbound_from_area,
        from_name: linked_line_data.outbound_from_name,
        from_type: linked_line_data.outbound_from_type,
        to_details: {
            requested_arrival_time: 30,
        },
        from_details: {
        //address: data?.transfers?.address
        },
    };
    // INBOUND
    transfer_line_config.transfer_legs.inbound = {
        to_area: linked_line_data.inbound_to_area,
        to_name: linked_line_data.inbound_to_name,
        to_type: linked_line_data.inbound_to_type,
        from_area: linked_line_data.inbound_from_area,
        from_name: linked_line_data.inbound_from_name,
        from_type: linked_line_data.inbound_from_type,
        to_details: {
        //address: data?.transfers.address
        },
        from_details: {
            requested_arrival_time: 30,
        },
    };
    transfer_line_config = await (0, searchTransferRatesIncludingHistorical_1.searchTransferRatesIncludingHistorical)(supabase, null, transfer_line_config, {
        id: linked_line_data.inbound_from_area,
        name: linked_line_data.inbound_from_name,
        type: linked_line_data.inbound_from_type,
        address: "",
    }, {
        id: linked_line_data.inbound_to_area,
        name: linked_line_data.inbound_to_name,
        type: linked_line_data.inbound_to_type,
        address: "",
    }, null, "RETURN", dayjs(linked_line_data.start_date).format("YYYY-MM-DD"), linked_line_data.number_of_passengers, order?.agent?.config?.margin?.transfers || 0);
    const golf_transfer_line_version = {
        id: (0, uuid_1.v4)(),
        order_line_id: golf_transfer_line.id,
        config: transfer_line_config,
        status: helpers_1.OrderLineStatus.DRAFT,
        supplier_id: undefined,
        region_id: linked_line_data.region_id,
        linked_line_id: golf_order_line_id,
        start_date: dayjs(linked_line_data.start_date).format("YYYY-MM-DD"),
        end_date: dayjs(linked_line_data.end_date).format("YYYY-MM-DD"),
        amount_paid: 0,
        amount_refunded: 0,
    };
    golf_transfer_line.versions = [golf_transfer_line_version];
    return golf_transfer_line;
};
exports.autoCreateLinkedGolfTransfer = autoCreateLinkedGolfTransfer;
